import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-[#FFF8F0] text-[#3D2B1F] px-4" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 md:p-12 border border-[#3D2B1F]/10 shadow-xl relative overflow-hidden" data-id="element-128">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500 to-orange-400" data-id="element-129"></div>

          <div className="flex items-center justify-center mb-8" data-id="element-130">
            <div className="bg-red-50 p-4 rounded-full" data-id="element-131">
              <AlertCircleIcon className="w-12 h-12 text-red-500" data-id="element-132" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 leading-tight text-[#3D2B1F]" data-id="element-133">
            Si te gusta cocinar cosas dulces en casa, seguramente te pasó esto…
          </h2>

          <div className="space-y-6 text-xl text-[#6B5344] font-medium text-center" data-id="element-134">
            <p className="bg-[#FFF8F0] p-6 rounded-2xl border border-[#3D2B1F]/5" data-id="element-135">
              Preparás un budín que queda rico… pero se ve simple.
            </p>
            <p className="bg-[#FFF8F0] p-6 rounded-2xl border border-[#3D2B1F]/5" data-id="element-136">
              O el sabor está bien… pero le falta algo para que realmente
              sorprenda.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}